import { render, staticRenderFns } from "./uploadAlerts.vue?vue&type=template&id=9b97c4ee&lang=html"
import script from "./uploadAlerts.vue?vue&type=script&lang=js"
export * from "./uploadAlerts.vue?vue&type=script&lang=js"
import style0 from "./uploadAlerts.vue?vue&type=style&index=0&id=9b97c4ee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports